import { defineMessages } from "react-intl";

const messages = defineMessages({
    groups: {
        id: "memory.header.groups",
    },
    slogen: {
        id: "memory.slogen",
    },
});

export default messages;
